<template>
  <v-data-table
    :headers="headers"
    :items="stores"
    class="elevation-1"
    sort-by="internalCode"
    :search="search"
    dense
    :loading="loading"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          label="Buscar"
          append-icon="mdi-magnify"
          class="mt-3 py-2 mr-2"
        ></v-text-field>
        <StoreDialog></StoreDialog>
      </v-toolbar>
    </template>
    <template v-slot:item.domains="{ item }">
      <ul>
        <li v-for="(domain, i) in item.domains" :key="i">
          {{ domain }}
        </li>
      </ul>
    </template>
    <template v-slot:item.urls="{ item }">
      <ul>
        <li v-for="(domain, i) in item.domains" :key="i">
          <a :href="`https://${domain}`" target="_blank" rel="noopener noreferrer"></a>
        </li>
        <li>
          <a :href="`https://shop.redabitscr.com/${item.slug}`" target="_blank" rel="noopener noreferrer"></a>
        </li>
      </ul>
    </template>
    <template v-slot:item.actions="{ item }">
      <store-dialog :item="item"></store-dialog>
    </template>
  </v-data-table>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import StoreDialog from '@/components/StoreDialog.vue'
// import firebaseApi from '../api/firebaseApi'
moment.locale('es')
export default {
  name: 'StoresTable',
  components: {
    StoreDialog
  },
  props: {
    stores: Array
  },
  data: () => ({
    dialog: false,
    search: null,
    loading: false,
    dialogItem: false
  }),

  mounted () {
  },

  computed: {
    headers () {
      return [
        { text: 'Nombre', value: 'name' },
        { text: 'Departamento encargado', value: 'cc' },
        { text: 'Dominios', value: 'domains' },
        { text: 'URLs', value: 'urls' },
        { text: '', value: 'actions', sortable: false }
      ]
    },
    ...mapGetters('user', [
      'getUser'
    ]),
    // ...mapGetters('products', [
    //   'getProducts'
    // ]),
    ...mapGetters('company', [
      'getCompany'
    ])
  },

  watch: {
  },

  methods: {
    emitUpdated () {
      this.$emit('updated')
    },

    getDateFormat (date) {
      return moment(date, 'x').format('L')
    },

    customFilter (item, queryText /* itemText /**/) {
      const textOne = item.name.toLowerCase()
      const textTwo = item.code.toString().toLowerCase()
      const searchText = queryText.toString().toLowerCase()

      return textOne.indexOf(searchText) > -1 ||
          textTwo.indexOf(searchText) > -1
    },

    editItem (item) {
    },

    deleteItem (item) {
    },

    save () {
    },
    ...mapActions('inventories', ['insertInventory'])

  }
}
</script>
